import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-abc26124"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "question-title-wrapper mb-14" }
const _hoisted_3 = { class: "question-title-index" }
const _hoisted_4 = {
  key: 0,
  class: "required-required"
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { class: "drop-down-actions" }
const _hoisted_8 = {
  key: 0,
  class: "category-list-wrapper"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "category-list-title" }, "Choose Group", -1))
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { key: 3 }
const _hoisted_12 = { class: "d-flex" }
const _hoisted_13 = { key: 4 }
const _hoisted_14 = {
  key: 0,
  class: "d-flex flex-wrap"
}
const _hoisted_15 = { key: 5 }
const _hoisted_16 = { key: 6 }
const _hoisted_17 = {
  key: 7,
  class: "question-error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_question_title = _resolveComponent("question-title")!
  const _component_question_option_input = _resolveComponent("question-option-input")!
  const _component_question_date_input = _resolveComponent("question-date-input")!
  const _component_option_drop_down_row = _resolveComponent("option-drop-down-row")!
  const _component_option_drop_down = _resolveComponent("option-drop-down")!
  const _component_radio_button = _resolveComponent("radio-button")!
  const _component_SearchMultipleSelect = _resolveComponent("SearchMultipleSelect")!
  const _component_select_input = _resolveComponent("select-input")!
  const _component_search_drop_down = _resolveComponent("search-drop-down")!
  const _component_FileUpload = _resolveComponent("FileUpload")!

  return (_ctx.currentCategory === _ctx.question.category_id)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        id: String(_ctx.question.id),
        class: "question-wrapper"
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.count) + ".", 1),
          _createVNode(_component_question_title, {
            value: _ctx.question.text,
            "is-active": false
          }, null, 8, ["value"])
        ]),
        (_ctx.question.is_required)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, "*"))
          : _createCommentVNode("", true),
        (_ctx.question.type === 'text')
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_question_option_input, {
                placeholder: "Type your response",
                value: _ctx.question.user_answer,
                onOnValueChange: _ctx.handleValueUpdate
              }, null, 8, ["value", "onOnValueChange"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.question.type === 'date')
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_question_date_input, {
                placeholder: "Date",
                value: typeof _ctx.question.user_answer === 'string' ? _ctx.question.user_answer : '',
                onOnValueChange: _ctx.handleValueUpdate
              }, null, 8, ["value", "onOnValueChange"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_option_drop_down, null, {
            default: _withCtx(() => [
              _createVNode(_component_option_drop_down_row, {
                text: "Edit Question",
                onHandleClick: _ctx.setEditMode
              }, null, 8, ["onHandleClick"]),
              _createVNode(_component_option_drop_down_row, {
                text: "Add Question",
                onHandleClick: _ctx.handleAddQuestion
              }, null, 8, ["onHandleClick"]),
              _createVNode(_component_option_drop_down_row, {
                class: "position-relative",
                text: "Move Question",
                onMouseover: _ctx.openCategoryDropDown,
                onMouseleave: _ctx.closeCategoryDropDown
              }, {
                default: _withCtx(() => [
                  (_ctx.isCategoryDropDownOpen)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _hoisted_9,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allCategories, (category) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: category.id,
                            class: "category-list-item",
                            onClick: ($event: any) => (_ctx.moveQuestionToCategory(category.id))
                          }, _toDisplayString(category.name), 9, _hoisted_10))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["onMouseover", "onMouseleave"]),
              _createVNode(_component_option_drop_down_row, {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('removeQuestion', _ctx.ix))),
                text: "Delete Question"
              })
            ]),
            _: 1
          })
        ]),
        (_ctx.question.type === 'yes_no')
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.question.answer_values, (k, v) => {
                  return (_openBlock(), _createBlock(_component_radio_button, {
                    key: k,
                    class: "mr-10",
                    label: k,
                    value: v,
                    "is-active": _ctx.isResponseSelected(v),
                    onHandleValueChange: _ctx.handleYesNoChange
                  }, null, 8, ["label", "value", "is-active", "onHandleValueChange"]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.question.type === 'multiple' || _ctx.question.type === 'multiple_checkbox')
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              (_ctx.question.answer_values && Object.keys(_ctx.question.answer_values).length < 4)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.question.answer_values, (k, v) => {
                      return (_openBlock(), _createBlock(_component_radio_button, {
                        key: k,
                        class: "mr-10 mb-6",
                        label: k,
                        value: v,
                        "is-active": _ctx.isResponseSelected(v),
                        onHandleValueChange: _ctx.handleMultipleChange
                      }, null, 8, ["label", "value", "is-active", "onHandleValueChange"]))
                    }), 128))
                  ]))
                : (_openBlock(), _createBlock(_component_SearchMultipleSelect, {
                    key: 1,
                    question: _ctx.question,
                    onOnUpdate: _ctx.handleValueUpdate
                  }, null, 8, ["question", "onOnUpdate"]))
            ]))
          : _createCommentVNode("", true),
        (_ctx.question.type === 'drop_down')
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              (Object.keys(_ctx.question.answer_values).length < 20)
                ? (_openBlock(), _createBlock(_component_select_input, {
                    key: 0,
                    value: _ctx.question.user_answer !== null ? _ctx.question.user_answer[0] : null,
                    options: _ctx.getSelectInputOptions(_ctx.question.answer_values),
                    onHandleChange: _ctx.handleSelectChange
                  }, null, 8, ["value", "options", "onHandleChange"]))
                : (_openBlock(), _createBlock(_component_search_drop_down, {
                    key: 1,
                    options: _ctx.getSearchSelectInputOptions(_ctx.question.answer_values),
                    onSelected: _ctx.handleSearchSelectChange,
                    defaultValue: _ctx.question.user_answer !== null ? {id: _ctx.question.user_answer[0], name: _ctx.question.answer_values[_ctx.question.user_answer[0]]} : null
                  }, null, 8, ["options", "onSelected", "defaultValue"]))
            ]))
          : _createCommentVNode("", true),
        (_ctx.question.type === 'file')
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createVNode(_component_FileUpload, {
                name: _ctx.question.user_answer !== null ? _ctx.question.user_answer : '',
                accept: _ctx.question?.attributes?.file_types ? `.${_ctx.question.attributes.file_types.join(', ')},` : '*.*',
                onUpload: _ctx.handleFileUpload,
                onHandleFileDownload: _ctx.handleFileDownload,
                onHandleFileRemove: _ctx.handleFileRemove
              }, null, 8, ["name", "accept", "onUpload", "onHandleFileDownload", "onHandleFileRemove"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_ctx.error), 1))
          : _createCommentVNode("", true)
      ], 8, _hoisted_1))
    : _createCommentVNode("", true)
}